import { apiSlice } from './apiSlice'

export const OnboardingStepType = {
  IMPORT_EMPLOYEES: 'IMPORT_EMPLOYEES',
  VERIFY_DOMAINS: 'VERIFY_DOMAINS',
  CONFIGURE_EMAIL_DELIVERY: 'CONFIGURE_EMAIL_DELIVERY',
  RUN_PHISHING_DRILL: 'RUN_PHISHING_DRILL'
}

export const OnboardingStepStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED'
}

const ONBOARDING_TAG = 'OnboardingSteps'

export const onboardingApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getOnboardingSteps: builder.query({
      query: () => '/v1/company-onboarding/steps',
      providesTags: result => (result ? [{ type: ONBOARDING_TAG, id: 'LIST' }] : [])
    }),

    completeOnboardingStep: builder.mutation({
      query: ({ type }) => ({
        url: `/v1/company-onboarding/steps/${type}/complete`,
        method: 'POST'
      }),
      invalidatesTags: () => [{ type: ONBOARDING_TAG, id: 'LIST' }]
    }),
    getServices: builder.query({
      query: () => '/v1/templates/services',
      providesTags: [{ type: 'Services', id: 'LIST' }]
    }),
    getCurrentServices: builder.query({
      query: () => '/v1/companies/current',
      providesTags: [{ type: 'Services', id: 'LIST' }]
    }),
    updateUsedServices: builder.mutation({
      query: usedProducts => ({
        url: '/v1/companies/current/used-products',
        method: 'PUT',
        body: { usedProducts }
      })
    }),
    bulkImportUsers: builder.mutation({
      query: users => ({
        url: '/v1/users/bulk',
        method: 'POST',
        body: { users }
      })
    }),
    sendSimulationEmail: builder.mutation({
      query: () => ({
        url: '/v1/company-onboarding/simulation-email',
        method: 'POST'
      })
    }),
    sendSimulationCampaign: builder.mutation({
      query: payload => ({
        url: '/v1/company-onboarding/simulation-campaign',
        method: 'POST',
        body: payload
      })
    })
  })
})

export const {
  useSendSimulationEmailMutation,
  useSendSimulationCampaignMutation,
  useGetCurrentServicesQuery,
  useUpdateUsedServicesMutation,
  useGetServicesQuery,
  useLazyGetOnboardingStepsQuery,
  useGetOnboardingStepsQuery,
  useCompleteOnboardingStepMutation,
  useBulkImportUsersMutation
} = onboardingApiSlice

export const useOnboardingStepStatus = stepType => {
  const { data: steps, ...queryInfo } = useGetOnboardingStepsQuery()
  const step = steps?.find(s => s.type === stepType)
  return {
    status: step?.status,
    isLoading: queryInfo.isLoading,
    isFetching: queryInfo.isFetching,
    error: queryInfo.error,
    isStepCompleted: step?.status === OnboardingStepStatus.COMPLETED
  }
}

export const useCurrentOnboardingStep = () => {
  const { data: steps, ...queryInfo } = useGetOnboardingStepsQuery()

  const currentStep = steps?.find(s => s.status === OnboardingStepStatus.IN_PROGRESS)

  return {
    currentStep,
    allStepsCompleted: steps?.every(s => s.status === OnboardingStepStatus.COMPLETED) && steps?.length > 0,
    ...queryInfo
  }
}
